import { createClient } from 'common/supabase/utils'
import { ENV_CONFIG } from 'common/envs/constants'

let currentToken: string | undefined

export function getSupabaseInstanceId() {
  return ENV_CONFIG.supabaseInstanceId
}

export function initSupabaseClient() {
  const instanceId = getSupabaseInstanceId()
  return createClient(instanceId, ENV_CONFIG.supabaseAnonKey)
}

// updateSupabaseAuth is no longer needed - Supabase Auth session is managed
// automatically by @supabase/ssr and the browser client.
export function updateSupabaseAuth(_token?: string) {
  // no-op: kept for backwards compat with any remaining imports
}

export const db = initSupabaseClient()
